import React, { useEffect, useState } from "react";
import ModalB from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import "./modal.css";
import "./modalPesquisa.css";

import useApp from "../../hooks/useAppContext";
import api from "../../services/axios";
import { BsStarFill, BsStar } from "react-icons/bs";

const ModalPesquisa = (props) => {
  const { verificaPesquisa } = useApp();
  const [tituloModal, setTituloModal] = useState(props.titulo);
  const [rate, setRate] = useState(0);

  useEffect(() => {
    setTituloModal(props.titulo);
  }, [props.titulo]);

  const handleModal = () => props.toggleModal();

  const handleResposta = async (rateDado) => {
    if (rateDado !== 0) {
      let resp = await api.post("responder-pesquisa", {
        id_agenda_participantes: props?.pesquisa?.id,
        rate: rateDado,
      });
      if (resp.data.pesquisa) {
        handleModal();
        verificaPesquisa();
        setRate(0);
        props.onRespondido?.();
      }
    } else {
      alert("Escolha uma opção!");
    }
  };

  const handleRespostaConteudo = async () => {
    if (rate !== 0) {
      let resp = await api.post("responder-pesquisa", {
        id_agenda_participantes: props?.pesquisa?.id,
        rate: rate,
      });
      if (resp.data.pesquisa) {
        setRate(0);
        handleModal();
        verificaPesquisa();
        props.onRespondido?.();
      }
    } else {
      alert("Escolha uma opção!");
    }
  };

  const ehReuniaoNegocio =
    props?.pesquisa?.agenda?.tipo === "reuniao_negocio" ||
    props?.pesquisa?.agenda?.tipo === "m_m";

  const nomeOutroParticipante =
    props?.participante?.usuario?.nome ||
    props?.pesquisa?.agenda?.participantes?.[
      props.tipoUsuario === "patrocinador" ? 0 : 1
    ]?.usuario?.nome ||
    "";

  const textoPergunta = `${
    props.texto
      ? props.texto
      : "Para fechar essa tela, por favor nos diga o que achou"
  } ${
    ehReuniaoNegocio
      ? `da reunião de negócios com ${nomeOutroParticipante}`
      : `do conteúdo: ${props?.pesquisa?.agenda?.nome || ""}`
  }`;

  return (
    <ModalB
      show={props.show}
      onHide={handleModal}
      backdrop="static"
      centered
      dialogClassName="modal-pesquisa-dialog"
    >
      <ModalB.Header closeButton={props.close}>
        <ModalB.Title className="titulo-modal">{tituloModal}</ModalB.Title>
      </ModalB.Header>
      <ModalB.Body>
        <div className="modal-pesquisa-corpo">
          <div className="texto-pesquisa">{textoPergunta}</div>

          {props.tipoUsuario !== "patrocinador" ? (
            <div className="aviso-pesquisa">
              Essa informação será compartilhada com o patrocinador / evento
            </div>
          ) : null}

          {ehReuniaoNegocio ? (
            <div className="area-btn-pesquisa">
              <button
                type="button"
                className={`btn-pesquisa-negocio${
                  rate === 5 ? " escolhido" : ""
                }`}
                onClick={() => setRate(5)}
              >
                Vamos fechar negócio
              </button>
              <button
                type="button"
                className={`btn-pesquisa-negocio${
                  rate === 4 ? " escolhido" : ""
                }`}
                onClick={() => setRate(4)}
              >
                Gerou proposta
              </button>
              <button
                type="button"
                className={`btn-pesquisa-negocio${
                  rate === 3 ? " escolhido" : ""
                }`}
                onClick={() => setRate(3)}
              >
                Aproximou relacionamento
              </button>
              <button
                type="button"
                className={`btn-pesquisa-negocio${
                  rate === 2 ? " escolhido" : ""
                }`}
                onClick={() => setRate(2)}
              >
                Não foi boa
              </button>
              <button
                type="button"
                className={`btn-pesquisa-negocio btn-pesquisa-enviar${
                  rate === 0 ? " desabilitado" : ""
                }`}
                onClick={() => handleResposta(rate)}
              >
                Enviar
              </button>
            </div>
          ) : (
            <div className="area-btn-star">
              <div className="modal-pesquisa-stars">
                {[1, 2, 3, 4, 5].map((valor) => (
                  <button
                    key={valor}
                    type="button"
                    className="btn-pesquisa-negocio-star"
                    onClick={() => setRate(valor)}
                    aria-label={`${valor} estrela${valor > 1 ? "s" : ""}`}
                  >
                    {rate >= valor ? <BsStarFill /> : <BsStar />}
                  </button>
                ))}
              </div>
              <button
                type="button"
                className={`btn-pesquisa-negocio btn-pesquisa-enviar${
                  rate === 0 ? " desabilitado" : ""
                }`}
                onClick={handleRespostaConteudo}
              >
                Enviar
              </button>
            </div>
          )}
        </div>
      </ModalB.Body>
      {props.to ? (
        <ModalB.Footer>
          <Link to={props.to} onClick={handleModal} className="link-padrao">
            {props.labelTo}
          </Link>
        </ModalB.Footer>
      ) : null}
    </ModalB>
  );
};

export default ModalPesquisa;
